var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditNameGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4465 4.86428C18.1648 4.153 18.1773 2.97059 17.4465 2.2469L15.7523 0.55272C15.0331 -0.169917 13.8575 -0.169917 13.1349 0.55272L11.683 2.00464L15.9946 6.3162L17.4465 4.86428Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7051 2.98265L0.584016 13.1071C0.469934 13.2177 0.400746 13.3664 0.383485 13.5254L0.0135001 17.2285C-0.00727721 17.4359 0.0653556 17.6399 0.214067 17.7852C0.341965 17.9165 0.518273 17.9892 0.701543 17.9892C0.725766 17.9892 0.746508 17.9892 0.77066 17.9857L4.47374 17.6158C4.63278 17.602 4.78146 17.5293 4.89554 17.4152L15.0166 7.29418L10.7051 2.98265Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNameGroup);
export default __webpack_public_path__ + "static/media/edit_name_group.8700a8604f9397a6e4c5a53d80848cb6.svg";
export { ForwardRef as ReactComponent };